import React from "react";
import { Route, BrowserRouter, Routes} from "react-router-dom";

import EstilosPerfil from "../styles/estilosPerfil";
import "../styles/globalStyle.scss";
import HistorialRegistroResoluciones from "../views/RegistroResolucionesJex/HistorialRegistroResoluciones";

function Routing() {
  return (
    <BrowserRouter>
      <EstilosPerfil />
      <Routes>
        <Route exact path="/registro-resoluciones" element={<HistorialRegistroResoluciones />} />
        <Route exact path="*" element={<HistorialRegistroResoluciones />} />
      </Routes>
    </BrowserRouter>
  );
}

export default Routing;
